import { FiltrosAvancado } from "../../interfaces/Planejamento";
import { Container } from "./styles";
import Grafico from "./partials/Grafico";
import { useFilters } from "core/features/filters/store";
import Operacional from "./partials/Operacional";
import DiarioOperacoes from "./partials/DiarioOperacoes";
import { useValidatePermission } from "core/features/auth/hooks/useValidatePermission";

type Props = {
    filtrosAvancados?: FiltrosAvancado;
};

function Relatorios({ filtrosAvancados }: Props) {
    const { filters: { menuNameRelatorios } } = useFilters();
    const { hasPermission } = useValidatePermission();
    const permissionProgramacaoOperacional = hasPermission(['Relatorios.CronogramaOperacional']);
    const permissionAnaliticoOperacional = hasPermission(['Relatorios.RelatorioAnaliticoOperacional']);
    const permissionDiarioOperacoes = hasPermission(['Relatorios.RelatorioDiarioOperacoesAgricolas']);
    return (
        <Container isGraphic={true}>
            {
                menuNameRelatorios === "Relatório Analítico Operacional" && (
                    <Operacional filtrosAvancados={filtrosAvancados} permission={permissionAnaliticoOperacional} />
                )
            }
            {
                menuNameRelatorios === "Relatório de Programação Operacional" && (
                    <Grafico filtrosAvancados={filtrosAvancados} permission={permissionProgramacaoOperacional} />
                )
            }
            {
                menuNameRelatorios === "Relatório Diário de Operações" && (
                    <DiarioOperacoes filtrosAvancados={filtrosAvancados}  permission={permissionDiarioOperacoes} />
                )
            }
        </Container>
    )
}

export default Relatorios;